export const chatAppDict = {
  facetime: "FaceTime",
  gruveo: "Gruveo",
  twilio: "VCC WebRTC",
};
